const KEY_PREFIX = 'kuutio.tooltip.';

export function tooltipStorageKey(id) {
  return `${KEY_PREFIX}${id}`;
}

/**
 * sessionStorage-backed "don't nag me this sitting" flags.
 * All access is try/catch'd — Safari private mode throws; failure
 * degrades to "not dismissed" and never crashes.
 *
 * @param {Storage|{getItem:Function,setItem:Function,removeItem:Function,key?:Function,length?:number}|(() => (Storage|null))|null} getStorage
 */
export function createTooltipDismissStore(getStorage) {
  function resolveStorage() {
    try {
      const storage = typeof getStorage === 'function' ? getStorage() : getStorage;
      return storage ?? null;
    } catch {
      return null;
    }
  }

  function isDismissed(id) {
    if (!id) return false;
    try {
      const storage = resolveStorage();
      if (!storage) return false;
      return storage.getItem(tooltipStorageKey(id)) === '1';
    } catch {
      return false;
    }
  }

  function dismiss(id) {
    if (!id) return;
    try {
      const storage = resolveStorage();
      if (!storage) return;
      storage.setItem(tooltipStorageKey(id), '1');
    } catch {
      /* storage unavailable */
    }
  }

  function clearAll() {
    try {
      const storage = resolveStorage();
      if (!storage) return;
      const keys = [];
      const len = storage.length ?? 0;
      for (let i = 0; i < len; i += 1) {
        const key = storage.key(i);
        if (key && key.startsWith(KEY_PREFIX)) keys.push(key);
      }
      keys.forEach((key) => storage.removeItem(key));
    } catch {
      /* storage unavailable */
    }
  }

  return { isDismissed, dismiss, clearAll };
}

function defaultSessionStorage() {
  try {
    return typeof sessionStorage === 'undefined' ? null : sessionStorage;
  } catch {
    return null;
  }
}

export const tooltipDismissStore = createTooltipDismissStore(defaultSessionStorage);

export const isDismissed = (id) => tooltipDismissStore.isDismissed(id);
export const dismiss = (id) => tooltipDismissStore.dismiss(id);
export const clearAll = () => tooltipDismissStore.clearAll();
